import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/returnSessionItems/{{returnSessionItemId}}'
const ENDPOINT_BOXES = `${ENDPOINT}/boxes`
const ENDPOINT_BOX_ID = `${ENDPOINT_BOXES}/{{boxId}}`

// Box Object:
// {
//   id: 123,                                    // Auto-increment integer
//   dateCreated: "2024-01-15T10:30:00.000Z",   // ISO timestamp
//   dateModified: "2024-01-15T11:45:00.000Z",  // ISO timestamp or null
//   returnSessionItemId: "507f1f77bcf86cd799439011", // 24-char string
//   length: 12.5,                               // Decimal (10,2)
//   width: 8.75,                                // Decimal (10,2)
//   height: 6.25,                               // Decimal (10,2)
//   weight: 3.5                                 // Decimal (10,2) or null
// }

export default {
  /**
   * creates a box for a return session item
   * @param {string} returnSessionItemId
   * @param {object} box
   * @param {number} box.length - inches as a decimal
   * @param {number} box.width - inches as a decimal
   * @param {number} box.height - inches as a decimal
   * @param {number} box.weight - pounds as a decimal
   * @returns {Promise} - { statusCode: 201, success: true, box: {...} }
   */
  createBox(returnSessionItemId, box) {
    return $fetch.peg(replacePathTokens(ENDPOINT_BOXES, { returnSessionItemId }), {
      method: 'POST',
      body: { ...box },
    })
  },

  /**
   * gets a box by ID
   * @param {string} returnSessionItemId
   * @param {string} boxId
   * @returns {Promise} - { statusCode: 200, message: "Success", data: { box: {...} } }
   */
  getBox(returnSessionItemId, boxId) {
    return $fetch.peg(replacePathTokens(ENDPOINT_BOX_ID, { returnSessionItemId, boxId }))
  },

  /**
   * get all boxes for a return session item
   * @param {string} returnSessionItemId
   * @returns {Promise} - { statusCode: 200, message: "Success", data: { boxes: [...] } }
   */
  getBoxes(returnSessionItemId) {
    return $fetch.peg(replacePathTokens(ENDPOINT_BOXES, { returnSessionItemId }))
  },

  /**
   * update a box by ID
   * @param {string} returnSessionItemId
   * @param {string} boxId
   * @param {object} box
   * @param {number} [box.length] - inches as a decimal
   * @param {number} [box.width] - inches as a decimal
   * @param {number} [box.height] - inches as a decimal
   * @param {number} [box.weight] - pounds as a decimal
   * @returns {Promise} - { statusCode: 200, success: true, box: {...} }
   */
  updateBox(returnSessionItemId, boxId, box) {
    return $fetch.peg(replacePathTokens(ENDPOINT_BOX_ID, { returnSessionItemId, boxId }), {
      method: 'PUT',
      body: { ...box },
    })
  },

  /**
   * deletes a box by ID
   * @param {string} returnSessionItemId
   * @param {string} boxId
   * @returns {Promise} - { statusCode: 200, message: "Success", data: { message: "Box deleted successfully" } }
   */
  deleteBox(returnSessionItemId, boxId) {
    return $fetch.peg(replacePathTokens(ENDPOINT_BOX_ID, { returnSessionItemId, boxId }), {
      method: 'DELETE',
    })
  },
}
